import React from 'react';

type ErrorStateProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
};

export function ErrorState({ title, description, children }: ErrorStateProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center px-6">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">{title}</h1>
        {description ? <p className="text-slate-500 mb-8 max-w-md">{description}</p> : null}
        {children}
      </div>
    </div>
  );
}

